module.exports = __webpack_public_path__ + "static/media/WebDev-sm_2x.76f1e981.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/WebDev/WebDev-sm_2x.webp
// module id = 774
// module chunks = 0